import * as React from 'react';
import {cn} from 'src/lib/utils';

type Props = Omit<React.ComponentProps<'button'>, 'onChange'>;

export const FormButton = React.forwardRef(
  (props: Props, ref: React.Ref<HTMLButtonElement>) => {
    const {className, ...otherProps} = props;
    return (
      <button
        ref={ref}
        {...otherProps}
        className={cn(
          'dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 shadow-xs transition-[color,box-shadow] outline-none disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
          'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
          'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
          className,
        )}
      />
    );
  },
);
